// extracted by mini-css-extract-plugin
export var heading = "hero-module--heading--2AXgd";
export var hero_section = "hero-module--hero_section--1f-fk";